import { buildDefaultRows } from './presets'

export const DEFAULT_CONFIG = {
  title: 'Components of Change',
  rowPreset: 'standard',
  rows: null,
  dateRanges: { default: { quickDate: 'YTD' } },
  bondAccrual: false,
  inceptionValueMethod: 'New Money',
  reportCategoryId: 2,
  showDrillDown: true,
  showDateControls: true,
  allowCustomDates: true,
  availableQuickDates: null,
  localStorageKey: null,
  valueFormat: 'marketValue',
  performanceFormat: 'returns',
  tableStyleVariant: 'default',
  tableStyleVariantParams: {}
}

export const INCEPTION_VALUE_OPTIONS = [
  { value: 'New Money', label: 'New Money' },
  { value: 'Zero', label: 'Zero' },
  { value: 'Day After', label: 'Day After' }
]

export const QUICK_DATE_OPTIONS = [
  { value: 'MTD', label: 'MTD' },
  { value: 'QTD', label: 'QTD' },
  { value: 'YTD', label: 'YTD' },
  { value: 'One Year', label: '1 Year' },
  { value: 'Two Year', label: '2 Year' },
  { value: 'Three Year', label: '3 Year' },
  { value: 'Five Year', label: '5 Year' },
  { value: 'Ten Year', label: '10 Year' },
  { value: 'Inception', label: 'Inception' },
  { value: 'Custom', label: 'Custom Range...' }
]

export const ROW_PRESET_OPTIONS = [
  { value: 'standard', label: 'Standard' },
  { value: 'detailed', label: 'Detailed' }
]

export const REPORT_CATEGORY_OPTIONS = [
  { value: 0, label: 'All' },
  { value: 2, label: 'Managed Activity Summary' }
]

export const CALC_IDS = {
  ACTIVITY_SUMMARY: 'Activity Summary',
  BEGINNING_MARKET_VALUE: 'BeginningMarketValue',
  ENDING_MARKET_VALUE: 'EndingMarketValue',
  BEGINNING_BOND_ACCRUAL: 'BeginningBondAccrual',
  ENDING_BOND_ACCRUAL: 'EndingBondAccrual',
  TRANSACTION_TOTAL: 'Transaction Total',
  PERFORMANCE_RETURN: 'PerformanceReturn'
}

export function mergeConfig (raw) {
  const merged = { ...DEFAULT_CONFIG, ...raw }

  // Backward compat: migrate old bucket field names
  if (merged.rows == null && raw?.buckets != null) {
    merged.rows = raw.buckets
  }
  if (raw?.bucketPreset != null && !raw?.rowPreset) {
    merged.rowPreset = raw.bucketPreset
  }

  // Hydrate rows from preset if still null
  if (merged.rows == null) {
    merged.rows = buildDefaultRows(merged.rowPreset || 'standard')
  }

  // Migrate legacy performanceCalc into rows if present
  if (raw?.performanceCalc?.method && Array.isArray(merged.rows)) {
    const method = raw.performanceCalc.method
    const matchKey = method === 'TWR' ? 'performance-twr' : 'performance-irr'
    const idx = merged.rows.findIndex(r => r.key === matchKey)
    if (idx !== -1 && !merged.rows[idx].enabled) {
      merged.rows = [...merged.rows]
      merged.rows[idx] = { ...merged.rows[idx], enabled: true }
      if (raw.performanceCalc.label) {
        merged.rows[idx].name = raw.performanceCalc.label
      }
    }
  }

  return merged
}
